export default "__VITE_PUBLIC_ASSET__2a027a99__"